import { generateNavLink } from "../../utils/generateNavLink";
import { isBlackFridaySaleEnabled, isLunarNewYearEnabled } from "../helpers/outdoor";

const mensCollectionsMenu = data => `
    <ul>
        ${generateNavLink({
          className: "sectionhead collection",
          text: data.Collection,
          dataPrefix: "men",
          dataLinkId: ["men", "collection"],
          tabIndex: 1,
        })}
        <div class="mobilefly">
            ${generateNavLink({
              className: "mobilehead",
              text: data.Collection,
              dataPrefix: "men",
            })}
            ${generateNavLink({
              className: "F24_Veilance_M_Nav",
              text: data["Veilance Name"],
              dataLinkId: ["men", "collection", "veilance"],
              blockArr: ["CN-block"],
              href: "/c/mens/veilance",
            })}
            ${generateNavLink({
              className: "professional-use",
              text: data["Professional Use"],
              dataPrefix: "men",
              dataLinkId: ["men", "collection", "professional-use"],
              href: "/c/mens/professional-use",
              blockArr: [],
            })}
            ${generateNavLink({
              className: "system_a",
              text: "System_A",
              dataPrefix: "men",
              dataLinkId: ["men", "collection", "system-a"],
              href: "/c/mens/system_a",
            })}
            ${generateNavLink({
              className: "SS24_WalkGently",
              text: "Walk Gently",
              dataLinkId: ["men", "collection", "walk-gently"],
              href: "/c/mens/walk-gently/wid-2jn408g9",
              blockArr: [
                "AT-block",
                "BE-block",
                "CZ-block",
                "DK-block",
                "FI-block",
                "FR-block",
                "DE-block",
                "GB-block",
                "IE-block",
                "IT-block",
                "NO-block",
                "PL-block",
                "ES-block",
                "SE-block",
                "CH-block",
                "NL-block",
                "CA-block",
                "US-block",
              ],
            })}
        </div>
    </ul>
`;

const mensClimbingMenu = data => `
    <ul>
        <div>
            ${generateNavLink({
              className: "sectionhead F24_ClimbingGear_M_Nav",
              text: data["Climbing Gear"],
              dataLinkId: ["men", "climbing-gear"],
              tabIndex: 1,
              href: "/c/mens/climbing-gear",
            })}
            <div class="mobilefly">
                ${generateNavLink({
                  className: "mobilehead",
                  text: data["Climbing Gear"],
                  dataPrefix: "men",
                })}
                ${generateNavLink({
                  className: "s23_climbing_gear_harness",
                  text: data["$^nav-harnesses^$"],
                  dataPrefix: "men",
                  dataLinkId: ["men", "climbing-gear", "harnesses"],
                  href: "/c/mens/climbing-gear/sub-cat=harnesses",
                })}
                ${generateNavLink({
                  className: "s23_climbing_gear_ropebags",
                  text: data["$^nav-chalkBags^$"],
                  dataPrefix: "men",
                  dataLinkId: ["men", "climbing-gear", "chalk-bags"],
                  href: "/c/mens/climbing-gear/sub-cat=chalk-bags",
                })}
            </div>
        </div>
    </ul>
`;

const mensFootwearMenu = data => `
    <ul>
        ${generateNavLink({
          className: "sectionhead F24_FTW_M_Nav",
          text: data.Footwear,
          dataLinkId: ["men", "footwear"],
          tabIndex: 1,
          href: "/c/mens/footwear",
        })}
        <div class="mobilefly">
            ${generateNavLink({
              className: "mobilehead",
              text: data.Footwear,
              dataPrefix: "men",
            })}
            ${generateNavLink({
              className: "s23_ftw_boots",
              text: data["$^nav-boots^$"],
              dataPrefix: "men",
              href: "/c/mens/footwear/sub-cat=boots",
              dataLinkId: ["men", "footwear", "boots"],
            })}
            ${generateNavLink({
              className: "s23_ftw_shoes",
              text: data["$^nav-shoes^$"],
              dataPrefix: "men",
              href: "/c/mens/footwear/sub-cat=shoes",
              dataLinkId: ["men", "footwear", "shoes"],
            })}
        </div>
        <li class="spacer">
            <span>&nbsp;</span>
        </li>
    </ul>
`;

const mensClothingMenu = data => `
    <ul>
        ${generateNavLink({
          className: "sectionhead F24_MensCollection_Nav",
          text: data.Clothing,
          dataLinkId: ["men", "clothing"],
          tabIndex: 1,
          href: "/c/mens",
        })}
        <div class="mobilefly">
            ${generateNavLink({
              className: "mobilehead",
              text: data.Clothing,
              dataPrefix: "men",
            })}
            ${generateNavLink({
              className: "F24_ShellJackets_M_Nav",
              text: data["Shell Jackets"],
              dataLinkId: ["men", "clothing", "shell-jackets"],
              href: "/c/mens/shell-jackets",
            })}
            ${generateNavLink({
              className: "F24_InsulatedJackets_M_Nav",
              text: data["Insulated Jackets"],
              dataLinkId: ["men", "clothing", "insulated-jackets"],
              href: "/c/mens/insulated-jackets",
            })}
            ${generateNavLink({
              className: "F24_Pants_M_Nav",
              text: data.Pants,
              href: "/c/mens/pants",
              dataLinkId: ["men", "clothing", "pants"],
            })}
            ${generateNavLink({
              className: "F24_Fleece_M_Nav",
              text: data.Fleece,
              href: "/c/mens/fleece",
              dataLinkId: ["men", "clothing", "fleece"],
            })}
            ${generateNavLink({
              className: "F24_BaseLayer_M_Nav",
              text: data["Base Layer"],
              href: "/c/mens/base-layer",
              dataLinkId: ["men", "clothing", "base-layer"],
              blockArr: ["JP-block"],
            })}
            ${generateNavLink({
              className: "F24_ShirtsTops_M_Nav",
              text: data["Shirts & Tops"],
              href: "/c/mens/shirts-and-tops",
              dataLinkId: ["men", "clothing", "shirts-and-tops"],
            })}
            ${generateNavLink({
              className: "F24_Shorts_M_Nav",
              text: data.Shorts,
              href: "/c/mens/shorts",
              dataLinkId: ["men", "clothing", "shorts"],
            })}
        </div>
    </ul>
`;

const mensPacksMenu = data => `
    <ul>
        ${generateNavLink({
          className: "sectionhead F24_Packs_M_Nav",
          text: data.Packs,
          dataLinkId: ["men", "packs"],
          tabIndex: 1,
          href: "/c/mens/packs",
        })}
        <div class="mobilefly">
            ${generateNavLink({
              className: "mobilehead",
              text: data.Packs,
              dataPrefix: "men",
            })}
            ${generateNavLink({
              className: "s23_packs_daypack",
              text: data["$^nav-daypacks^$"],
              dataLinkId: ["men", "packs", "daypacks"],
              href: "/c/mens/packs/sub-cat=daypacks",
              dataPrefix: "men",
            })}
            ${generateNavLink({
              className: "s23_packs_multiday",
              text: data["$^nav-multiDay^$"],
              dataLinkId: ["men", "packs", "multi-day"],
              href: "/c/mens/packs/sub-cat=multi-day",
              dataPrefix: "men",
            })}
            ${generateNavLink({
              className: "s23_packs_travelcommute",
              text: data["$^nav-travelAndCommute^$"],
              dataPrefix: "men",
              dataLinkId: ["men", "packs", "travel-and-commute"],
              href: "/c/mens/packs/sub-cat=travel-and-commute",
            })}
              ${generateNavLink({
                className: "f24_packs_avalancheairbags",
                text: data["$^nav-avalancheAirbags^$"],
                dataPrefix: "men",
                dataLinkId: ["men", "packs", "avalanche-airbags"],
                href: "/c/mens/packs/sub-cat=avalancheairbags",
              })}
        </div>
    </ul>
`;

const mensAccessoriesMenu = data => `
    <ul>
        ${generateNavLink({
          className: "sectionhead F24_Accessories_M_Nav",
          text: data.Accessories,
          dataLinkId: ["men", "accessories"],
          tabIndex: 1,
          href: "/c/mens/accessories",
        })}
        <div class="mobilefly">
            ${generateNavLink({
              className: "mobilehead",
              text: data.Accessories,
              dataPrefix: "men",
            })}
            ${generateNavLink({
              className: "F24_Gloves_Nav",
              text: data["$^nav-gloves^$"],
              dataLinkId: ["men", "accessories", "gloves"],
              href: "/c/mens/accessories/sub-cat=gloves",
            })}
            ${generateNavLink({
              className: "F24_ToquesBeanie_M_Nav",
              text: data["$^nav-toquesAndBeanies^$"],
              dataLinkId: ["men", "accessories", "toques-and-beanies"],
              href: "/c/mens/accessories/sub-cat=toques-and-beanies",
            })}
            ${generateNavLink({
              className: "F24_HatsCaps_Nav",
              text: data["$^nav-hatsAndCaps^$"],
              dataLinkId: ["men", "accessories", "hats-and-caps"],
              href: "/c/mens/accessories/sub-cat=hats-and-caps",
            })}
            ${generateNavLink({
              className: "F24_Socks_M_Nav",
              text: data.Socks,
              dataLinkId: ["men", "accessories", "socks"],
              href: "/c/mens/accessories/sub-cat=socks",
            })}
            ${generateNavLink({
              className: "s23_accessories_productcare",
              text: data["$^ProductCare^$"],
              dataLinkId: ["men", "accessories", "product-care"],
              href: "/c/mens/accessories/sub-cat=product-care",
              dataPrefix: "men",
            })}
            ${generateNavLink({
              className: "s23_accessories_more",
              text: data["$^nav-more^$"],
              dataLinkId: ["men", "accessories", "more"],
              href: "/c/mens/accessories/sub-cat=more",
              dataPrefix: "men",
            })}
        </div>
    </ul>
`;

const menActivityEvolutionClimb = data => `
    <ul class="activity-evolution-climb">
        ${generateNavLink({
          className: "sectionhead F24_AlpineRockClimb_M_Nav",
          href: "/c/mens/climb",
          text: data.Climbing,
          tabIndex: 1,
          dataLinkId: ["men", "climb"],
        })}
        <div class="mobilefly">
            ${generateNavLink({
              className: "mobilehead",
              text: data.Climbing,
              dataPrefix: "men",
            })}
            ${generateNavLink({
              className: "F24_AlpineClimb_M_Nav",
              text: data.Alpine,
              href: "/c/mens/climb/alpine",
              dataLinkId: ["men", "climb", "alpine"],
            })}
            ${generateNavLink({
              className: "F24_RockClimb_M_Nav",
              text: data.Rock,
              href: "/c/mens/climb/rock",
              dataLinkId: ["men", "climb", "rock"],
            })}
            ${generateNavLink({
              className: "F24_Bouldering_M_Nav",
              text: data.Boulder,
              href: "/c/mens/climb/boulder",
              dataLinkId: ["men", "climb", "boulder"],
            })}
        </div>
    </ul>
`;

const menActivityEvolutionTrail = data => `
    <ul class="activity-evolution-trail">
        ${generateNavLink({
          className: "sectionhead F24_TrailRunning_M_Nav",
          href: "/c/mens/trail",
          text: data.Trail,
          tabIndex: 1,
          dataLinkId: ["men", "trail"],
        })}
        <div class="mobilefly">
            ${generateNavLink({
              className: "mobilehead",
              text: data.Trail,
              dataPrefix: "men",
            })}
            ${generateNavLink({
              className: "F24_RunMountain_M_Nav",
              text: data["Mountain Run"],
              href: "/c/mens/trail/mountain-run",
              dataLinkId: ["men", "trail", "mountain-run"],
            })}
            ${generateNavLink({
              className: "F24_HikeTrekk_M_Nav",
              text: data.Hike,
              href: "/c/mens/trail/hike",
              dataLinkId: ["men", "trail", "hike"],
            })}
            ${generateNavLink({
              className: "F24_EverydayEssentials_M_Nav",
              text: data.EverydayEvolution,
              href: "/c/mens/trail/everyday",
              dataLinkId: ["men", "trail", "everyday"],
            })}
        </div>
    </ul>
`;

const menActivityEvolutionSki = data => `
    <ul class="activity-evolution-ski">
        ${generateNavLink({
          className: "sectionhead F24_SkiSB_M_Nav US-only remove-subcats",
          href: "/c/mens/ski-snowboard",
          text: data["Ski-and-Snowboard"],
          tabIndex: 1,
          dataLinkId: ["men", "ski-snowboard"],
        })}
        ${generateNavLink({
          className: "sectionhead F24_SkiSB_M_Nav US-block",
          href: "/c/mens/ski-snowboard",
          text: data["Ski-and-Snowboard"],
          tabIndex: 1,
          dataLinkId: ["men", "ski-snowboard"],
        })}
        <div class="mobilefly">
            ${generateNavLink({
              className: "mobilehead US-block",
              text: data["Ski-and-Snowboard"],
            })}
            ${generateNavLink({
              className: "F24_SkiSBTouring_M_Nav US-block",
              text: data.Touring,
              href: "/c/mens/ski-snowboard/touring",
              dataLinkId: ["men", "ski-snowboard", "touring"],
            })}
            ${generateNavLink({
              className: "F24_SkiSBFreeride_M_Nav US-block",
              text: data.Freeride,
              href: "/c/mens/ski-snowboard/freeride",
              dataLinkId: ["men", "ski-snowboard", "freeride"],
            })}
            ${generateNavLink({
              className: "F24_SkiSBResort_M_Nav US-block",
              text: data.Resort,
              href: "/c/mens/ski-snowboard/resort",
              dataLinkId: ["men", "ski-snowboard", "resort"],
            })}
        </div>
    </ul>
`;

export const mensShopMoreMenu = (data, country) => `
    <ul class="shopmore">
        ${generateNavLink({
          className: "sectionhead shop-more",
          text: data["$^nav-ShopMore^$"],
          dataPrefix: "men",
          tabIndex: 1,
        })}
        <div class="mobilefly">
            ${generateNavLink({
              className: "mobilehead",
              text: data["$^nav-ShopMore^$"],
              dataPrefix: "men",
              dataLinkId: ["men", "shop-more"],
            })}
            ${
              isBlackFridaySaleEnabled(country)
                ? generateNavLink({
                    className: "f23_blackfridaysale black-friday",
                    text: data["Black Friday Sale"],
                    dataPrefix: "men",
                    dataLinkId: ["sale", "black-friday-sale-mens"],
                    href: "/c/mens/p/black-friday-sale",
                  })
                : ""
            }
            ${generateNavLink({
              className: "F24_NewArrivals_M_Nav",
              text: data["New Arrivals"],
              dataLinkId: ["men", "shop-more", "new-arrivals"],
              href: "/c/mens/new-arrivals",
            })}
            ${generateNavLink({
              className: "s24_gifts_for_him",
              text: data["Gifts for Him"],
              dataPrefix: "men",
              dataLinkId: ["men", "shop-more", "gifts-for-him"],
              href: "/c/mens/gifts-for-him/wid-o9ge1z7j",
            })}
            ${generateNavLink({
              className: "ski-and-snowboard-gear-guide",
              text: data["Best Sellers"],
              dataPrefix: "men",
              dataLinkId: ["men", "shop-more", "ski-and-snowboard-collection"],
              href: "/c/mens/best-sellers/wid-dlk87r1l",
            })}
            ${generateNavLink({
              className: "grottoflage",
              text: "Grottoflage",
              dataPrefix: "men",
              dataLinkId: ["men", "shop-more", "grottoflage"],
              href: "/c/mens/grottoflage/wid-p9p17dg9",
            })}
            ${generateNavLink({
              className: "F24_BackInStock_M_Nav",
              text: data.Exclusives,
              dataLinkId: ["men", "shop-more", "exclusives"],
              href: "/c/mens/back-in-stock/wid-ojd1gwnj",
            })}
            ${generateNavLink({
              className: "whats-your-warmest",
              text: data["What's Your Warmest"],
              dataPrefix: "men",
              dataLinkId: ["men", "shop-more", "whats-your-warmest"],
              href: "/c/mens/whats-your-warmest/wid-1jwrp2ml",
            })}
            ${generateNavLink({
              className: "f23_shellfinder",
              text: data["$^nav-shellFinder^$"],
              dataPrefix: "men",
              dataLinkId: ["men", "shop-more", "shell-finder"],
              href: "/shop/jacket-finder/mens",
            })}
            ${generateNavLink({
              className: "footwear-finder",
              text: data["$^nav-footwearFinder^$"],
              dataPrefix: "men",
              dataLinkId: ["men", "shop-more", "footwear-finder"],
              href: "/shop/footwear-finder",
            })}
            ${generateNavLink({
              className: "layering-guide",
              text: data["$^nav-layering-guide^$"],
              dataPrefix: "men",
              dataLinkId: ["men", "shop-more", "layering-guide"],
              href: "/shop/mens-layering-guide",
            })}
            ${generateNavLink({
              className: "F24_Travel_M_Nav",
              text: data["$^nav-travelCollection^$"],
              dataLinkId: ["men", "shop-more", "travel-collection"],
              href: "/shop/mens-travel-collection",
            })}
            ${
              isLunarNewYearEnabled()
                ? generateNavLink({
                    className: "lunar-new-year",
                    text: data["Year of the Dragon Capsule"],
                    dataPrefix: "men",
                    dataLinkId: ["men", "shop-more", "lunar-new-year"],
                    href: "/shop/lunar-new-year",
                  })
                : ""
            }
        </div>
    </ul>
`;

const mensShoppingCategoryMenusFdp = (data, country) => `
    ${mensClothingMenu(data)}

    <div class="group">
        ${mensPacksMenu(data)}
        ${mensFootwearMenu(data)}
    </div>
    <div class="group">
        ${mensAccessoriesMenu(data)}
        ${mensClimbingMenu(data)}
    </div>
    <div class="nav-item__divider"></div>
    <div class="group">
        ${menActivityEvolutionClimb(data)}
        ${menActivityEvolutionTrail(data)}
        ${menActivityEvolutionSki(data)}
    </div>
    <div class="nav-item__divider"></div>
    ${mensCollectionsMenu(data)}
    <div class="nav-item__divider"></div>
    ${mensShopMoreMenu(data, country)}
`;

export const mensShoppingCategoryMenu = (data, country) => mensShoppingCategoryMenusFdp(data, country);
